// @ts-ignore
import memoize from 'memoize-weak';

import toLegacyCompatibleService from '@zapier/services/esm/utils/toLegacyCompatibleService';

import { Service } from '@zapier/services/esm/types';

const combineToLegacyCompatibleServices = memoize(
  (
    publicServices: Array<Service>,
    privateServices: Array<Service>,
    includePrivateServices: boolean
  ) => {
    const consumerServices = includePrivateServices
      ? publicServices.concat(privateServices)
      : publicServices;

    const legacyCompatibleServices = consumerServices.map(
      toLegacyCompatibleService
    );
    return legacyCompatibleServices;
  }
);

export default combineToLegacyCompatibleServices;
